import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';
import FormLabel from '~/components/FormLabel/FormLabel';
import Input from '~/components/Input';

import { ContactLinkValues } from './ContactLink.types';

export const ContactLink = React.forwardRef<
  HTMLFormElement,
  FormikProps<ContactLinkValues>
>(
  (
    { errors, handleBlur, handleChange, handleSubmit, isSubmitting, values },
    ref,
  ) => {
    return (
      <>
        <Form onSubmit={handleSubmit} ref={ref}>
          <FormControl id="email" isInvalid={!!errors.email} marginBottom={6}>
            <FormLabel fontWeight={400} fontSize="md" marginBottom={3}>
              Your email (this will apply to contact links on all Media Packs
              and you can update it anytime):
            </FormLabel>
            <Input
              value={values.email}
              isDisabled={isSubmitting}
              onBlur={handleBlur}
              onChange={handleChange}
              placeholder="charliewilliams@gmail.com"
              size="md"
              type="text"
              width="100%"
              maxWidth="300px"
            />
            <FormErrorMessage data-testid="error-email">
              {errors.email}
            </FormErrorMessage>
          </FormControl>
        </Form>
      </>
    );
  },
);
